import Enum from '/@/modules/core/app/helpers/Enum';
import { JurisdictionAdministrativeDivisionDescriptor } from '/@/modules/predefined/enums/JurisdictionAdministrativeDivisionDescriptor';
import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import { removeAccents } from '/@/modules/core/app/helpers/StringHelper';
import { JurisdictionLanguage } from '/@/modules/predefined/models/JurisdictionLanguage';

export class PredefinedJurisdiction extends Enum {
  id!: number;
  name!: string;
  code!: string;
  country!: PredefinedCountry;
  administrativeDivisionDescriptor!: string;
  languages?: JurisdictionLanguage[];

  static ALBERTA: PredefinedJurisdiction = {
    id: 1,
    name: 'Alberta',
    code: 'AB',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static BRITISH_COLUMBIA: PredefinedJurisdiction = {
    id: 2,
    name: 'British Columbia',
    code: 'BC',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static MANITOBA: PredefinedJurisdiction = {
    id: 3,
    name: 'Manitoba',
    code: 'MB',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static NEW_BRUNSWICK: PredefinedJurisdiction = {
    id: 4,
    name: 'New Brunswick',
    code: 'NB',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static NEWFOUNDLAND_AND_LABRADOR: PredefinedJurisdiction = {
    id: 5,
    name: 'Newfoundland and Labrador',
    code: 'NL',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static NORTHWEST_TERRITORIES: PredefinedJurisdiction = {
    id: 6,
    name: 'Northwest Territories',
    code: 'NT',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.TERRITORY.key
  };

  static NOVA_SCOTIA: PredefinedJurisdiction = {
    id: 7,
    name: 'Nova Scotia',
    code: 'NS',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static NUNAVUT: PredefinedJurisdiction = {
    id: 8,
    name: 'Nunavut',
    code: 'NU',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.TERRITORY.key
  };

  static ONTARIO: PredefinedJurisdiction = {
    id: 9,
    name: 'Ontario',
    code: 'ON',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static PRINCE_EDWARD_ISLAND: PredefinedJurisdiction = {
    id: 10,
    name: 'Prince Edward Island',
    code: 'PE',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static QUEBEC: PredefinedJurisdiction = {
    id: 11,
    name: 'Québec',
    code: 'QC',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key,
    languages: [
      new JurisdictionLanguage('fr', 'fr-u-sd-caqc', 'fr-CA'),
      new JurisdictionLanguage('en', 'en-u-sd-caqc', 'en')
    ]
  };

  static SASKATCHEWAN: PredefinedJurisdiction = {
    id: 12,
    name: 'Saskatchewan',
    code: 'SK',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.PROVINCE.key
  };

  static YUKON: PredefinedJurisdiction = {
    id: 13,
    name: 'Yukon',
    code: 'YT',
    country: PredefinedCountry.CANADA,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.TERRITORY.key
  };

  static ALABAMA: PredefinedJurisdiction = {
    id: 14,
    name: 'Alabama',
    code: 'AL',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static ALASKA: PredefinedJurisdiction = {
    id: 15,
    name: 'Alaska',
    code: 'AK',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static ARIZONA: PredefinedJurisdiction = {
    id: 16,
    name: 'Arizona',
    code: 'AZ',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static ARKANSAS: PredefinedJurisdiction = {
    id: 17,
    name: 'Arkansas',
    code: 'AR',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static CALIFORNIA: PredefinedJurisdiction = {
    id: 18,
    name: 'California',
    code: 'CA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static COLORADO: PredefinedJurisdiction = {
    id: 19,
    name: 'Colorado',
    code: 'CO',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static CONNECTICUT: PredefinedJurisdiction = {
    id: 20,
    name: 'Connecticut',
    code: 'CT',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static DELAWARE: PredefinedJurisdiction = {
    id: 21,
    name: 'Delaware',
    code: 'DE',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static DISTRICT_OF_COLUMBIA: PredefinedJurisdiction = {
    id: 22,
    name: 'District of Columbia',
    code: 'DC',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.DISTRICT.key
  };

  static FLORIDA: PredefinedJurisdiction = {
    id: 23,
    name: 'Florida',
    code: 'FL',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static GEORGIA: PredefinedJurisdiction = {
    id: 24,
    name: 'Georgia',
    code: 'GA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static HAWAII: PredefinedJurisdiction = {
    id: 25,
    name: 'Hawaii',
    code: 'HI',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static IDAHO: PredefinedJurisdiction = {
    id: 26,
    name: 'Idaho',
    code: 'ID',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static ILLINOIS: PredefinedJurisdiction = {
    id: 27,
    name: 'Illinois',
    code: 'IL',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static INDIANA: PredefinedJurisdiction = {
    id: 28,
    name: 'Indiana',
    code: 'IN',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static IOWA: PredefinedJurisdiction = {
    id: 29,
    name: 'Iowa',
    code: 'IA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static KANSAS: PredefinedJurisdiction = {
    id: 30,
    name: 'Kansas',
    code: 'KS',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static KENTUCKY: PredefinedJurisdiction = {
    id: 31,
    name: 'Kentucky',
    code: 'KY',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static LOUISIANA: PredefinedJurisdiction = {
    id: 32,
    name: 'Louisiana',
    code: 'LA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MAINE: PredefinedJurisdiction = {
    id: 33,
    name: 'Maine',
    code: 'ME',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MARYLAND: PredefinedJurisdiction = {
    id: 34,
    name: 'Maryland',
    code: 'MD',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MASSACHUSETTS: PredefinedJurisdiction = {
    id: 35,
    name: 'Massachusetts',
    code: 'MA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MICHIGAN: PredefinedJurisdiction = {
    id: 36,
    name: 'Michigan',
    code: 'MI',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MINNESOTA: PredefinedJurisdiction = {
    id: 37,
    name: 'Minnesota',
    code: 'MN',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MISSISSIPPI: PredefinedJurisdiction = {
    id: 38,
    name: 'Mississippi',
    code: 'MS',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MISSOURI: PredefinedJurisdiction = {
    id: 39,
    name: 'Missouri',
    code: 'MO',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static MONTANA: PredefinedJurisdiction = {
    id: 40,
    name: 'Montana',
    code: 'MT',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NEBRASKA: PredefinedJurisdiction = {
    id: 41,
    name: 'Nebraska',
    code: 'NE',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NEVADA: PredefinedJurisdiction = {
    id: 42,
    name: 'Nevada',
    code: 'NV',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NEW_HAMPSHIRE: PredefinedJurisdiction = {
    id: 43,
    name: 'New Hampshire',
    code: 'NH',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NEW_JERSEY: PredefinedJurisdiction = {
    id: 44,
    name: 'New Jersey',
    code: 'NJ',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NEW_MEXICO: PredefinedJurisdiction = {
    id: 45,
    name: 'New Mexico',
    code: 'NM',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NEW_YORK: PredefinedJurisdiction = {
    id: 46,
    name: 'New York',
    code: 'NY',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NORTH_CAROLINA: PredefinedJurisdiction = {
    id: 47,
    name: 'North Carolina',
    code: 'NC',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static NORTH_DAKOTA: PredefinedJurisdiction = {
    id: 48,
    name: 'North Dakota',
    code: 'ND',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static OHIO: PredefinedJurisdiction = {
    id: 49,
    name: 'Ohio',
    code: 'OH',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static OKLAHOMA: PredefinedJurisdiction = {
    id: 50,
    name: 'Oklahoma',
    code: 'OK',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static OREGON: PredefinedJurisdiction = {
    id: 51,
    name: 'Oregon',
    code: 'OR',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static PENNSYLVANIA: PredefinedJurisdiction = {
    id: 52,
    name: 'Pennsylvania',
    code: 'PA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static RHODE_ISLAND: PredefinedJurisdiction = {
    id: 53,
    name: 'Rhode Island',
    code: 'RI',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static SOUTH_CAROLINA: PredefinedJurisdiction = {
    id: 54,
    name: 'South Carolina',
    code: 'SC',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static SOUTH_DAKOTA: PredefinedJurisdiction = {
    id: 55,
    name: 'South Dakota',
    code: 'SD',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static TENNESSEE: PredefinedJurisdiction = {
    id: 56,
    name: 'Tennessee',
    code: 'TN',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static TEXAS: PredefinedJurisdiction = {
    id: 57,
    name: 'Texas',
    code: 'TX',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static UTAH: PredefinedJurisdiction = {
    id: 58,
    name: 'Utah',
    code: 'UT',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static VERMONT: PredefinedJurisdiction = {
    id: 59,
    name: 'Vermont',
    code: 'VT',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static VIRGINIA: PredefinedJurisdiction = {
    id: 60,
    name: 'Virginia',
    code: 'VA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static WASHINGTON: PredefinedJurisdiction = {
    id: 61,
    name: 'Washington',
    code: 'WA',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static WEST_VIRGINIA: PredefinedJurisdiction = {
    id: 62,
    name: 'West Virginia',
    code: 'WV',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static WISCONSIN: PredefinedJurisdiction = {
    id: 63,
    name: 'Wisconsin',
    code: 'WI',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static WYOMING: PredefinedJurisdiction = {
    id: 64,
    name: 'Wyoming',
    code: 'WY',
    country: PredefinedCountry.UNITED_STATES,
    administrativeDivisionDescriptor: JurisdictionAdministrativeDivisionDescriptor.STATE.key
  };

  static isROC(jurisdictionId: number): boolean {
    return (
      jurisdictionId !== PredefinedJurisdiction.QUEBEC.id &&
      PredefinedJurisdiction.isCanadianJurisdiction(jurisdictionId)
    );
  }

  static getNameByKey(key: string): string | undefined {
    return this.getByKey(key, 'id')?.name;
  }

  static getAllCanadianJurisdictions(): PredefinedJurisdiction[] {
    return this.getValues<PredefinedJurisdiction>().filter(
      (jurisdiction: PredefinedJurisdiction) =>
        jurisdiction.country.id === PredefinedCountry.CANADA.id
    );
  }

  static getAllCanadianJurisdictionsIds(): number[] {
    return PredefinedJurisdiction.getAllCanadianJurisdictions().map(
      (jurisdiction: PredefinedJurisdiction) => jurisdiction.id
    );
  }

  static isCanadianJurisdiction(id: number): boolean {
    return PredefinedJurisdiction.getAllCanadianJurisdictionsIds().includes(id);
  }

  static getAllAmericanJurisdictions(): PredefinedJurisdiction[] {
    return this.getValues<PredefinedJurisdiction>().filter(
      (jurisdiction: PredefinedJurisdiction) =>
        jurisdiction.country.id === PredefinedCountry.UNITED_STATES.id
    );
  }

  static getAllAmericanJurisdictionsIds(): number[] {
    return PredefinedJurisdiction.getAllAmericanJurisdictions().map(
      (jurisdiction: PredefinedJurisdiction) => jurisdiction.id
    );
  }

  static getAllAmericanCommonLawJurisdictions(): PredefinedJurisdiction[] {
    return [PredefinedJurisdiction.TEXAS];
  }

  static getAllAmericanCommonLawJurisdictionsIds(): number[] {
    return PredefinedJurisdiction.getAllAmericanCommonLawJurisdictions().map(
      (jurisdiction: PredefinedJurisdiction) => jurisdiction.id
    );
  }

  static getCommonLawJurisdictionsIds(): number[] {
    return PredefinedJurisdiction.getAllCanadianJurisdictionsIds().concat(
      PredefinedJurisdiction.getAllAmericanCommonLawJurisdictionsIds()
    );
  }

  static getCommonLawLegalUnionJurisdictions(): PredefinedJurisdiction[] {
    return [PredefinedJurisdiction.TEXAS];
  }

  static isCommonLawJurisdiction(id: number): boolean {
    return PredefinedJurisdiction.getCommonLawJurisdictionsIds().includes(id);
  }

  static getEntitledNextOfKinCommonLawJurisdictionIds(): number[] {
    return PredefinedJurisdiction.getCommonLawJurisdictionsIds().filter((id: number) => {
      return [PredefinedJurisdiction.BRITISH_COLUMBIA.id].includes(id);
    });
  }

  static isAmericanJurisdiction(id: number): boolean {
    return PredefinedJurisdiction.getAllAmericanJurisdictionsIds().includes(id);
  }

  static getCommonLawLegalUnionJurisdictionsIds(): number[] {
    return PredefinedJurisdiction.getCommonLawLegalUnionJurisdictions().map(
      (jurisdiction: PredefinedJurisdiction) => jurisdiction.id
    );
  }

  static isCommonLawLegalUnionJurisdiction(id: number): boolean {
    return PredefinedJurisdiction.getCommonLawLegalUnionJurisdictionsIds().includes(id);
  }

  static getByKey<PredefinedJurisdiction>(
    this: { new (): PredefinedJurisdiction },
    key: string | number,
    prop?: keyof PredefinedJurisdiction
  ): PredefinedJurisdiction | undefined {
    const propKey: keyof PredefinedJurisdiction = prop ?? ('id' as keyof PredefinedJurisdiction);

    if (prop === 'name') {
      return super
        .getValues<PredefinedJurisdiction>()
        .find(
          (item: PredefinedJurisdiction) =>
            removeAccents(item[propKey] as unknown as string) === removeAccents(key as string)
        );
    }

    // @ts-ignore
    return super.getByKey<PredefinedJurisdiction>(key, propKey);
  }
}
